<template>
  <div id="inside" style="margin-bottom: 100px" :class="largura >= 500 ? 'page-wrapper-desktop' : ''">
    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
        <div class="row">
          <div class="col-12 text-body px-2 mb-2">
            <button
              class="justify-content-left text-decoration-none btn-link flex-row d-flex align-items-center pr-2 pb-2 pl-1 text-primary"
              @click="home()"
            >
              <i class="fa fa-chevron-left fa-fw pull-left text-info"></i>
              Voltar
            </button>
          </div>
        </div>
      </div>
      <div
        class=""
        v-if="
          (negociarPagamentoTotalAlreadyCalled || !negociarPagamentoTotalAlreadyCalled) &&
          !loadOffers &&
          !loadOffersPst &&
          showAccordingRules !== 'pst'
        "
      >
        <h5 class="m-2 mb-4" style="color: black">Você está negociando</h5>
      </div>
      <div
        class=""
        v-if="
          negociarPagamentoTotalAlreadyCalled &&
          !loadOffers &&
          !loadOffersPst &&
          !onlyInCash &&
          showAccordingRules === 'pst'

        "
      >
        <h5 class="m-2 mb-4" style="color: black">
          Você está negociando o saldo total
        </h5>
      </div>
    </div>

    <!-- OPÇÕES PARCELAMENTO FATURA -->
    <template v-if="topOffer === 'parcelamento_fatura'">
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="!loadOffers && !loadOffersPst">
        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
          <div class="card pt-4 pb-4">
            <div class="col-12">
              <h5 class="mb-0 d-flex flex-row align-items-center">
                {{ offerInfo.product }}
              </h5>
              <p class="mb-1" style="font-size: 8pt">
                Contrato: {{ offerInfo.contract }}
              </p>
            </div>
            <hr class="mr-3 ml-3" />
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Valor da fatura em aberto:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatFloatToReal(parseFloat(offerInfo.originalValue, 10)) }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Vencimento fatura:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatData(offerInfo.dueDate, "YYYY-MM-DD", "L") }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">Dias de atraso:</p>
              <p class="mb-0" style="font-weight: bold">
                {{ offerInfo.daysDelay }}
              </p>
            </div>
          </div>
        </div>

        <div class="container mt-2 pl-2" v-if="!loadOffers">
          <h5 class="text-bold mt-4" style="color: black">
            Opções de pagamento da fatura
          </h5>

          <HeaderOptions />
        </div>

        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="cardOffers && !loadOffers">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"
              v-for="(value, key, index) in cardOffers.paymentOptions"
              :key="`${key}-${index}`"
            >
              <div
                class="card p-0"
                :style="largura < 500 ? '' : 'min-height: 258px !important;'"
              >
                <div class="banner" v-if="value.installmentsNumber === 1">
                  <!-- <span class="icon">🔥</span> -->
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 12 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px; margin-bottom: 4px"
                  >
                    <path
                      d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                      fill="#2C3DA8"
                    />
                  </svg>

                  <span class="banner-text">MELHOR OFERTA!</span>
                </div>

                <div class="card-body p-4 border-top-0 py-2">
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5
                        class="text-bold mb-0"
                        style="color: black"
                        v-if="value.installmentsNumber === 1"
                      >
                        Pagamento à vista
                      </h5>
                      <h5
                        class="text-bold"
                        style="color: black"
                        v-if="value.installmentsNumber !== 1"
                      >
                        Pagamento parcelado
                      </h5>
                    </div>
                  </div>

                  <!-- PARA MOBILE -->
                  <div class="row mt-3" v-if="largura < 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12 p-0"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PARA DESKTOP -->
                  <div class="row mt-3" v-if="largura > 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12 p-0"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pb-1" v-if="value.installmentsNumber === 1">
                    <div
                      class="d-flex mt-2 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber === 1"
                    >
                      <p class="mb-0 mr-1">Vencimento:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>
                  <div
                    class="row pb-1 mt-3"
                    v-if="value.installmentsNumber !== 1"
                  >
                    <div
                      class="d-flex mt-1 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber !== 1"
                    >
                      <p class="mb-1 mr-1">Vencimento da entrada:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>

                  <div class="row pb-2 mt-0">
                    <div class="col-xs-8 col-lg-12 col-12 text-center">
                      <button
                        class="btn btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordo(value)"
                        v-if="value.installmentsNumber === 1"
                      >
                        PAGAR À VISTA
                      </button>
                      <button
                        class="btn mb-2 btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordo(value)"
                        v-else
                        :disabled="
                          !isEmptyObject(selectedOption) &&
                          selectedOption !== 'Selecionar' &&
                          !negociarPagamentoTotal
                        "
                      >
                        PAGAR PARCELADO EM {{ value.installmentsNumber }}X
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!loadOffers"></div>
      </div>
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="loadOffers || loadOffersPst">
        <ProgressLoading v-bind:loading="loadOffers || loadOffersPst" />
      </div>
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="!loadOffers && !loadOffersPst">
        <div class="row my-3 mx-auto border-info py-4" v-if="largura < 500">
          <div class="col-lg-4 my-3">
            <h5 class="mt-3">Ou escolha outra opção parcelada:</h5>
          </div>
          <div class="col-lg-4 mt-0">
            <div class="form-group">
              <div
                class=""
                v-if="selectOtherOffers && !loadOffers && !loadOffersPst"
              ></div>
              <div
                class="custom-select-wrapper form-group"
                v-if="selectOtherOffers && !loadOffers"
              >
                <select
                  id="ParcelasSelectPst"
                  class="form-control custom-select-arrow mt-2"
                  @change="getValuePst($event.target.value)"
                >
                  <option
                    v-for="(
                      value, key, index
                    ) in selectOtherOffers.paymentOptions"
                    :key="`${key}-${index}`"
                    :value="JSON.stringify(value)"
                  >
                    {{ value.installmentsNumber }}x
                    {{
                      formatFloatToReal(parseFloat(value.installmentValue, 10))
                    }}
                  </option>
                  <option v-if="!newOffersLoaded">Carregar mais opções</option>
                  <option v-if="newOffersLoaded && !othersOptionsLoaded">
                    Outras opções de negociação
                  </option>
                  <option v-if="selectOtherOffers.paymentOptions.length < 1">
                    Não existem mais opções disponíveis
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="my-3 text-center col-lg-2">
            <button
              class="btn mb-2 btn-primary p-3"
              style="width: 100%; border-radius: 20px"
              :disabled="
                selectOtherOffers.paymentOptions.length < 1 ||
                selectedOption === 'Selecione outra opção' ||
                isEmptyObject(selectedOption)
              "
              @click="resumoAcordo(null)"
            >
              Confirmar
            </button>
          </div>
        </div>
        <div
          class="row border-bottom my-3 mx-auto border-info py-1"
          style="align-items: center"
          v-if="largura > 500 && !loadOffers && !loadOffersPst"
        >
          <div class="col-lg-4">
            <h5>Ou escolha outra opção parcelada da fatura:</h5>
          </div>
          <div class="my-3 text-center col-lg-4">
            <div class="">
              <div
                class="custom-select-wrapper form-group"
                v-if="selectOtherOffers && !loadOffers"
              >
                <select
                  id="ParcelasSelectPst"
                  class="form-control custom-select-arrow mt-2"
                  @change="getValue($event.target.value)"
                >
                  <option
                    v-for="(
                      value, key, index
                    ) in selectOtherOffers.paymentOptions"
                    :key="`${key}-${index}`"
                    :value="JSON.stringify(value)"
                  >
                    {{ value.installmentsNumber }}x
                    {{
                      formatFloatToReal(parseFloat(value.installmentValue, 10))
                    }}
                  </option>
                  <option v-if="!newOffersLoaded && !maxPaymentsOptionReached">Carregar mais opções</option>
                  <option
                    v-if="
                      negociarPagamentoTotal &&
                      newOffersLoaded &&
                      !othersOptionsLoaded
                      && !maxPaymentsOptionReached
                    "
                  >
                    Outras opções de negociação
                  </option>
                  <option v-if="selectOtherOffers.paymentOptions.length < 1">
                    Não existem mais opções disponíveis
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="my-3 text-center col-lg-4">
            <button
              class="btn mb-2 btn-primary p-3"
              style="width: 100%; border-radius: 20px"
              :disabled="
                selectOtherOffers.paymentOptions.length < 1 ||
                selectedOption === 'Selecione outra opção' ||
                isEmptyObject(selectedOption)
              "
              @click="resumoAcordo(null)"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>

      <div
        class="container"
        v-if="pstEligibleClient && !loadOffers && !loadOffersPst && !onlyInCash"
      >
        <div v-if="largura > 500" class="row my-3 mx-auto border-info py-2"></div>
        <div class="container pl-2 mb-4" v-if="!loadOffers">
          <h5 class="text-bold" style="color: black">
            Se desejar negocie o saldo total
          </h5>

          <HeaderOptions />
        </div>
        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
          <div class="card pt-4 pb-4">
            <div class="col-12">
              <h5 class="mb-0 d-flex flex-row align-items-center">
                {{ offerInfo.product }}
              </h5>
              <p class="mb-1" style="font-size: 8pt">
                Contrato: {{ offerInfo.contract }}
              </p>
            </div>
            <hr class="mr-3 ml-3" />
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Saldo total da dívida:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{
                  formatFloatToReal(parseFloat(offerInfo.pstOriginalValue, 10))
                }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Vencimento fatura:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatData(offerInfo.dueDate, "YYYY-MM-DD", "L") }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">Dias de atraso:</p>
              <p class="mb-0" style="font-weight: bold">
                {{ offerInfo.daysDelay }}
              </p>
            </div>
          </div>
        </div>

        <div class="container mt-2 pl-2" v-if="!loadOffers">
          <h5 class="text-bold mt-4" style="color: black">
            Opções de parcelamento saldo total
          </h5>

          <HeaderOptions />
        </div>

        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="pstCardOffers && pstCardOffers.paymentOptions && pstCardOffers.paymentOptions.length > 0 && !loadOffers">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"
              v-for="(value, key, index) in pstCardOffers.paymentOptions"
              :key="`${key}-${index}`"
            >
              <div
                class="card p-0"
                :style="largura < 500 ? '' : 'min-height: 258px !important;'"
              >
                <div class="banner" v-if="key === 0">
                  <!-- <span class="icon">🔥</span> -->
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 12 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px; margin-bottom: 4px"
                  >
                    <path
                      d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                      fill="#2C3DA8"
                    />
                  </svg>

                  <span class="banner-text">MELHOR PLANO!</span>
                </div>

                <div class="card-body p-4 border-top-0 py-2">
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5
                        class="text-bold mb-0"
                        style="color: black"
                        v-if="value.installmentsNumber === 1"
                      >
                        Pagamento à vista
                      </h5>
                      <h5
                        class="text-bold"
                        style="color: black"
                        v-if="value.installmentsNumber !== 1"
                      >
                        Pagamento parcelado
                      </h5>
                    </div>
                  </div>

                  <!-- PARA MOBILE PST -->
                  <div class="row mt-3" v-if="largura < 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}*
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                        <div
                          class="d-flex mb-0 price-current"
                          v-if="value.installmentsNumber === 1"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <p class="mt-1 ml-2 mb-0" style="font-weight: bold">
                            à vista
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PARA DESKTOP PST -->
                  <div class="row mt-3" v-if="largura > 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}*
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="value.installmentsNumber === 1">
                    <div
                      class="d-flex mt-2 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber === 1"
                    >
                      <p class="mb-0 mr-1">Vencimento:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>
                  <div
                    class="row pb-1 mt-3"
                    v-if="value.installmentsNumber !== 1"
                  >
                    <div
                      class="d-flex mt-1 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber !== 1"
                    >
                      <p class="mb-1 mr-1">Vencimento da entrada:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>

                  <div class="row pb-2 mt-0">
                    <div class="col-xs-8 col-lg-12 col-12 text-center">
                      <button
                        class="btn btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordoPst(value)"
                        v-if="value.installmentsNumber === 1"
                      >
                        PAGAR À VISTA
                      </button>
                      <button
                        class="btn mb-2 btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordoPst(value)"
                        v-else
                        :disabled="
                          !isEmptyObject(selectedOption) &&
                          selectedOption !== 'Selecionar' &&
                          !negociarPagamentoTotal
                        "
                      >
                        PAGAR PARCELADO EM {{ value.installmentsNumber }}X
                      </button>
                      <p class="text-info mb-0 pb-0" style="font-size: 12px">
                        *O valor da parcela será acrescido do IOF
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!loadOffers"></div>
        <div class="" v-if="!loadOffers && !onlyInCash">
          <div
            class="row border-bottom my-3 mx-auto border-info py-1"
            v-if="largura < 500 && !loadOffers && !loadOffersPst"
          >
            <div class="col-lg-4 my-3">
              <h5 class="mt-3">Ou escolha outra opção parcelada:</h5>
            </div>
            <div class="col-lg-4 mt-0">
              <div class="form-group">
                <div
                  class="custom-select-wrapper form-group"
                  v-if="selectPstOtherOffers && !loadOffers"
                >
                  <select
                    id="ParcelasSelectPst"
                    class="form-control custom-select-arrow mt-2"
                    @change="getValuePst($event.target.value)"
                  >
                    <option
                      v-for="(
                        value, key, index
                      ) in selectPstOtherOffers.paymentOptions"
                      :key="`${key}-${index}`"
                      :value="JSON.stringify(value)"
                    >
                      {{ value.installmentsNumber }}x
                      {{
                        formatFloatToReal(
                          parseFloat(value.installmentValue, 10)
                        )
                      }}
                    </option>
                    <option v-if="!newOffersLoaded">
                      Carregar mais opções
                    </option>
                    <option v-if="newOffersLoaded && !othersOptionsLoaded">
                      Outras opções de negociação
                    </option>
                    <option
                      v-if="selectPstOtherOffers.paymentOptions.length < 1"
                    >
                      Não existem mais opções disponíveis
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="my-3 text-center col-lg-2">
              <button
                class="btn mb-2 btn-primary p-3"
                style="width: 100%; border-radius: 20px"
                :disabled="
                  selectPstOtherOffers.paymentOptions.length < 1 ||
                  pstSelectedOption === 'Selecione outra opção' ||
                  isEmptyObject(pstSelectedOption)
                "
                @click="resumoAcordoPst(null)"
              >
                Confirmar
              </button>
            </div>
          </div>
          <div
            class="row border-bottom mx-auto border-info py-4"
            style="align-items: center"
            v-if="largura > 500 && !loadOffers && !loadOffersPst"
          >
            <div class="col-lg-4">
              <h5>Ou escolha outra opção parcelada:</h5>
            </div>
            <div class="my-3 text-center col-lg-4">
              <div class="">
                <div
                  class="custom-select-wrapper form-group"
                  v-if="selectPstOtherOffers && !loadOffers"
                >
                  <select
                    id="ParcelasSelectPst"
                    class="form-control custom-select-arrow mt-2"
                    @change="getValuePst($event.target.value)"
                  >
                    <option
                      v-for="(
                        value, key, index
                      ) in selectPstOtherOffers.paymentOptions"
                      :key="`${key}-${index}`"
                      :value="JSON.stringify(value)"
                    >
                      {{ value.installmentsNumber }}x
                      {{
                        formatFloatToReal(
                          parseFloat(value.installmentValue, 10)
                        )
                      }}
                    </option>
                    <option v-if="!newOffersLoaded">
                      Carregar mais opções
                    </option>
                    <option v-if="newOffersLoaded && !othersOptionsLoaded">
                      Outras opções de negociação
                    </option>
                    <option
                      v-if="selectPstOtherOffers.paymentOptions.length < 1"
                    >
                      Não existem mais opções disponíveis
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="my-3 text-center col-lg-4">
              <button
                class="btn mb-2 btn-primary p-3"
                style="width: 100%; border-radius: 20px"
                :disabled="
                  selectPstOtherOffers.paymentOptions.length < 1 ||
                  pstSelectedOption === 'Selecione outra opção' ||
                  isEmptyObject(pstSelectedOption)
                "
                @click="resumoAcordoPst(null)"
              >
                Confirmar
              </button>
            </div>
            <!-- <div class="mt-3 m-auto">
          <a
            @click="resumoAcordo(cardOffers.paymentOptions[0])"
            style="color: #0046c0; text-decoration: underline; cursor: pointer"
            >Quero a melhor oferta</a
          >
        </div> -->
          </div>
        </div>
      </div>
    </template>

    <!-- OPÇÕES PST -->
    <template v-else>
      <div
        class="container"
        v-if="
          pstEligibleClient &&
          !loadOffers &&
          !loadOffersPst &&
          showAccordingRules === 'pst'
        "
      >
        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
          <div class="card pt-4 pb-4">
            <div class="col-12">
              <h5 class="mb-0 d-flex flex-row align-items-center">
                {{ offerInfo.product }}
              </h5>
              <p class="mb-1" style="font-size: 8pt">
                Contrato: {{ offerInfo.contract }}
              </p>
            </div>
            <hr class="mr-3 ml-3" />
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Saldo total da dívida:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{
                  formatFloatToReal(parseFloat(offerInfo.pstOriginalValue, 10))
                }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Vencimento fatura:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatData(offerInfo.dueDate, "YYYY-MM-DD", "L") }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">Dias de atraso:</p>
              <p class="mb-0" style="font-weight: bold">
                {{ offerInfo.daysDelay }}
              </p>
            </div>
          </div>
        </div>

        <div class="container mt-2 pl-2" v-if="!loadOffers">
          <h5 class="text-bold mt-4" style="color: black">
            Opções de parcelamento saldo total
          </h5>

          <HeaderOptions />
        </div>

        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="pstCardOffers && pstCardOffers.paymentOptions && pstCardOffers.paymentOptions.length > 0 && !loadOffers">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"
              v-for="(value, key, index) in pstCardOffers.paymentOptions"
              :key="`${key}-${index}`"
            >
              <div
                class="card p-0"
                :style="largura < 500 ? '' : 'min-height: 258px !important;'"
              >
                <div class="banner" v-if="key === 0">
                  <!-- <span class="icon">🔥</span> -->
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 12 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px; margin-bottom: 4px"
                  >
                    <path
                      d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                      fill="#2C3DA8"
                    />
                  </svg>

                  <span class="banner-text">MELHOR PLANO!</span>
                </div>

                <div class="card-body p-4 border-top-0 py-2">
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5
                        class="text-bold mb-0"
                        style="color: black"
                        v-if="value.installmentsNumber === 1"
                      >
                        Pagamento à vista
                      </h5>
                      <h5
                        class="text-bold"
                        style="color: black"
                        v-if="value.installmentsNumber !== 1"
                      >
                        Pagamento parcelado
                      </h5>
                    </div>
                  </div>

                  <!-- PARA MOBILE PST -->
                  <div class="row mt-3" v-if="largura < 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}*
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                        <div
                          class="d-flex mb-0 price-current"
                          v-if="value.installmentsNumber === 1"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <p class="mt-1 ml-2 mb-0" style="font-weight: bold">
                            à vista
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PARA DESKTOP PST -->
                  <div class="row mt-3" v-if="largura > 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}*
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="value.installmentsNumber === 1">
                    <div
                      class="d-flex mt-2 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber === 1"
                    >
                      <p class="mb-0 mr-1">Vencimento:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>
                  <div
                    class="row pb-1 mt-3"
                    v-if="value.installmentsNumber !== 1"
                  >
                    <div
                      class="d-flex mt-1 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber !== 1"
                    >
                      <p class="mb-1 mr-1">Vencimento da entrada:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>

                  <div class="row pb-2 mt-0">
                    <div class="col-xs-8 col-lg-12 col-12 text-center">
                      <button
                        class="btn btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordoPst(value)"
                        v-if="value.installmentsNumber === 1"
                      >
                        PAGAR À VISTA
                      </button>
                      <button
                        class="btn mb-2 btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordoPst(value)"
                        v-else
                        :disabled="
                          !isEmptyObject(selectedOption) &&
                          selectedOption !== 'Selecionar' &&
                          !negociarPagamentoTotal
                        "
                      >
                        PAGAR PARCELADO EM {{ value.installmentsNumber }}X
                      </button>
                      <p class="text-info mb-0 pb-0" style="font-size: 12px">
                        *O valor da parcela será acrescido do IOF
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!loadOffers"></div>
        <div class="" v-if="!loadOffers && !onlyInCash">
          <div
            class="row border-bottom my-3 mx-auto border-info py-1"
            v-if="largura < 500 && !loadOffers && !loadOffersPst"
          >
            <div class="col-lg-4 my-3">
              <h5 class="mt-3">Ou escolha outra opção parcelada:</h5>
            </div>
            <div class="col-lg-4 mt-0">
              <div class="form-group">
                <div
                  class="custom-select-wrapper form-group"
                  v-if="selectPstOtherOffers && !loadOffers"
                >
                  <select
                    id="ParcelasSelectPst"
                    class="form-control custom-select-arrow mt-2"
                    @change="getValuePst($event.target.value)"
                  >
                    <option
                      v-for="(
                        value, key, index
                      ) in selectPstOtherOffers.paymentOptions"
                      :key="`${key}-${index}`"
                      :value="JSON.stringify(value)"
                    >
                      {{ value.installmentsNumber }}x
                      {{
                        formatFloatToReal(
                          parseFloat(value.installmentValue, 10)
                        )
                      }}
                    </option>
                    <option v-if="!newOffersLoaded">
                      Carregar mais opções
                    </option>
                    <option v-if="newOffersLoaded && !othersOptionsLoaded">
                      Outras opções de negociação
                    </option>
                    <option
                      v-if="selectPstOtherOffers.paymentOptions.length < 1"
                    >
                      Não existem mais opções disponíveis
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="my-3 text-center col-lg-2">
              <button
                class="btn mb-2 btn-primary p-3"
                style="width: 100%; border-radius: 20px"
                :disabled="
                  selectPstOtherOffers.paymentOptions.length < 1 ||
                  pstSelectedOption === 'Selecione outra opção' ||
                  isEmptyObject(pstSelectedOption)
                "
                @click="resumoAcordoPst(null)"
              >
                Confirmar
              </button>
            </div>
          </div>
          <div
            class="row border-bottom mx-auto border-info py-4"
            style="align-items: center"
            v-if="largura > 500 && !loadOffers && !loadOffersPst"
          >
            <div class="col-lg-4">
              <h5>Ou escolha outra opção parcelada:</h5>
            </div>
            <div class="my-3 text-center col-lg-4">
              <div class="">
                <div
                  class="custom-select-wrapper form-group"
                  v-if="selectPstOtherOffers && !loadOffers"
                >
                  <select
                    id="ParcelasSelectPst"
                    class="form-control custom-select-arrow mt-2"
                    @change="getValuePst($event.target.value)"
                  >
                    <option
                      v-for="(
                        value, key, index
                      ) in selectPstOtherOffers.paymentOptions"
                      :key="`${key}-${index}`"
                      :value="JSON.stringify(value)"
                    >
                      {{ value.installmentsNumber }}x
                      {{
                        formatFloatToReal(
                          parseFloat(value.installmentValue, 10)
                        )
                      }}
                    </option>
                    <option v-if="!newOffersLoaded">
                      Carregar mais opções
                    </option>
                    <option v-if="newOffersLoaded && !othersOptionsLoaded">
                      Outras opções de negociação
                    </option>
                    <option
                      v-if="selectPstOtherOffers.paymentOptions.length < 1"
                    >
                      Não existem mais opções disponíveis
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="my-3 text-center col-lg-4">
              <button
                class="btn mb-2 btn-primary p-3"
                style="width: 100%; border-radius: 20px"
                :disabled="
                  selectPstOtherOffers.paymentOptions.length < 1 ||
                  pstSelectedOption === 'Selecione outra opção' ||
                  isEmptyObject(pstSelectedOption)
                "
                @click="resumoAcordoPst(null)"
              >
                Confirmar
              </button>
            </div>
            <!-- <div class="mt-3 m-auto">
          <a
            @click="resumoAcordo(cardOffers.paymentOptions[0])"
            style="color: #0046c0; text-decoration: underline; cursor: pointer"
            >Quero a melhor oferta</a
          >
        </div> -->
          </div>
        </div>
        <div v-if="largura > 500" class="row my-3 mx-auto border-info py-2"></div>
        <hr>
        <div class="container pl-2 mb-4" v-if="!loadOffers">
          <h5 class="text-bold" style="color: black">
            Se desejar negocie apenas sua fatura
          </h5>

          <HeaderOptions />
        </div>
      </div>
      <div v-if="largura > 500" class="row my-3 mx-auto border-info py-2"></div>
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="!loadOffers && !loadOffersPst">
        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
          <div class="card pt-4 pb-4">
            <div class="col-12">
              <h5 class="mb-0 d-flex flex-row align-items-center">
                {{ offerInfo.product }}
              </h5>
              <p class="mb-1" style="font-size: 8pt">
                Contrato: {{ offerInfo.contract }}
              </p>
            </div>
            <hr class="mr-3 ml-3" />
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Valor da fatura em aberto:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatFloatToReal(parseFloat(offerInfo.originalValue, 10)) }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">
                Vencimento fatura:
              </p>
              <p class="mb-0" style="font-weight: bold">
                {{ formatData(offerInfo.dueDate, "YYYY-MM-DD", "L") }}
              </p>
            </div>
            <div class="d-flex col-lg-12 col-12">
              <p class="mb-0 mr-2" style="font-size: 10pt">Dias de atraso:</p>
              <p class="mb-0" style="font-weight: bold">
                {{ offerInfo.daysDelay }}
              </p>
            </div>
          </div>
        </div>

        <div class="container mt-2 pl-2" v-if="!loadOffers">
          <h5 class="text-bold mt-4" style="color: black">
            Opções de pagamento da fatura
          </h5>

          <HeaderOptions />
        </div>

        <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="cardOffers && !loadOffers">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"
              v-for="(value, key, index) in cardOffers.paymentOptions"
              :key="`${key}-${index}`"
            >
              <div
                class="card p-0"
                :style="largura < 500 ? '' : 'min-height: 258px !important;'"
              >
                <div class="banner" v-if="value.installmentsNumber === 1">
                  <!-- <span class="icon">🔥</span> -->
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 12 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px; margin-bottom: 4px"
                  >
                    <path
                      d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                      fill="#2C3DA8"
                    />
                  </svg>

                  <span class="banner-text">MELHOR OFERTA!</span>
                </div>

                <div class="card-body p-4 border-top-0 py-2">
                  <div class="row">
                    <div class="col-lg-12 col-12">
                      <h5
                        class="text-bold mb-0"
                        style="color: black"
                        v-if="value.installmentsNumber === 1"
                      >
                        Pagamento à vista
                      </h5>
                      <h5
                        class="text-bold"
                        style="color: black"
                        v-if="value.installmentsNumber !== 1"
                      >
                        Pagamento parcelado
                      </h5>
                    </div>
                  </div>

                  <!-- PARA MOBILE -->
                  <div class="row mt-3" v-if="largura < 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                        <div
                          class="d-flex mb-0 price-current"
                          v-if="value.installmentsNumber === 1"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <p class="mt-1 ml-2 mb-0" style="font-weight: bold">
                            à vista
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PARA DESKTOP -->
                  <div class="row mt-3" v-if="largura > 500">
                    <div class="d-flex flex-column col-12">
                      <div
                        class="d-flex"
                        style="justify-content: flex-end"
                        v-if="
                          value.discount > 0 && value.installmentsNumber === 1
                        "
                      >
                        <!-- <small
                        style="font-size: 9pt; font-weight: 500; color: black"
                      >
                        Desconto de até
                      </small> -->
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center mb-0"
                        v-if="value.installmentsNumber === 1"
                      >
                        <p
                          class="price-current mb-0"
                          style="font-size: 16pt; font-weight: bold"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <span
                            v-if="value.discount > 0"
                            style="font-size: 10pt"
                            >à vista</span
                          >
                        </p>

                        <!-- <div class="d-flex flex-column align-items-end">
                        <div
                          class="discount-value float-right mt-0"
                          style=""
                          v-if="value.discount > 0"
                        >
                          {{ value.discount.toFixed(2) }}%
                        </div>
                      </div> -->
                      </div>

                      <div
                        class="mb-0"
                        v-if="value.installmentsNumber !== 1"
                        style="justify-content: space-between"
                      >
                        <p class="mr-2 mb-0">
                          Entrada de

                          <!-- <span
                          class="float-right"
                          style="font-size: 9pt; font-weight: 500"
                          v-if="value.discount > 0"
                          >Desconto de</span
                        > -->
                        </p>
                        <div style="align-items: center">
                          <p class="price-current mb-0" style="font-size: 16pt">
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                            <!-- <span
                            class="discount-value float-right mt-0"
                            style="font-weight: 500; font-size: 12pt"
                            v-if="value.discount > 0"
                            >{{ value.discount.toFixed(2) }}%</span
                          > -->
                          </p>
                          <p class="mr-2 pt-0 mb-0">
                            + {{ value.installmentsNumber - 1 }}x de
                            {{
                              formatFloatToReal(
                                parseFloat(value.installmentValue, 10)
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-column col-12"
                        v-if="value.discount < 0"
                      >
                        <div
                          class="text-info price-line"
                          v-if="value.discount > 0"
                        >
                          <p class="mr-2 mb-0">De</p>
                          <span class="line-through">
                            {{
                              formatFloatToReal(
                                parseFloat(offerInfo.paymentValue, 10)
                              )
                            }}
                          </span>
                          <p class="ml-2 mb-0">por</p>
                        </div>
                        <div
                          class="d-flex mb-0 price-current"
                          v-if="value.installmentsNumber === 1"
                        >
                          {{
                            formatFloatToReal(
                              parseFloat(value.installmentValue, 10)
                            )
                          }}
                          <p class="mt-1 ml-2 mb-0" style="font-weight: bold">
                            à vista
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pb-1" v-if="value.installmentsNumber === 1">
                    <div
                      class="d-flex mt-2 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber === 1"
                    >
                      <p class="mb-0 mr-1">Vencimento:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>
                  <div
                    class="row pb-1 mt-3"
                    v-if="value.installmentsNumber !== 1"
                  >
                    <div
                      class="d-flex mt-1 col-12 col-lg-12 justify-content-center"
                      v-if="value.installmentsNumber !== 1"
                    >
                      <p class="mb-1 mr-1">Vencimento da entrada:</p>
                      <b
                        ><p style="font-size: 10pt">
                          {{
                            formatData(cardOffers.dueDate, "YYYY-MM-DD", "L")
                          }}
                        </p></b
                      >
                    </div>
                  </div>

                  <div class="row pb-2 mt-0">
                    <div class="col-xs-8 col-lg-12 col-12 text-center">
                      <button
                        class="btn btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordo(value)"
                        v-if="value.installmentsNumber === 1"
                      >
                        PAGAR À VISTA
                      </button>
                      <button
                        class="btn mb-2 btn-primary p-3"
                        style="width: 100%; border-radius: 20px"
                        @click="resumoAcordo(value)"
                        v-else
                        :disabled="
                          !isEmptyObject(selectedOption) &&
                          selectedOption !== 'Selecionar' &&
                          !negociarPagamentoTotal
                        "
                      >
                        PAGAR PARCELADO EM {{ value.installmentsNumber }}X
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!loadOffers"></div>
      </div>
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="loadOffers || loadOffersPst">
        <ProgressLoading v-bind:loading="loadOffers || loadOffersPst" />
      </div>
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="!loadOffers && !loadOffersPst">
        <div class="row my-3 mx-auto border-info py-4" v-if="largura < 500">
          <div class="col-lg-4 my-3">
            <h5 class="mt-3">Ou escolha outra opção parcelada:</h5>
          </div>
          <div class="col-lg-4 mt-0">
            <div class="form-group">
              <div
                class=""
                v-if="selectOtherOffers && !loadOffers && !loadOffersPst"
              ></div>
              <div
                class="custom-select-wrapper form-group"
                v-if="selectOtherOffers && !loadOffers"
              >
                <select
                  id="ParcelasSelectPst"
                  class="form-control custom-select-arrow mt-2"
                  @change="getValuePst($event.target.value)"
                >
                  <option
                    v-for="(
                      value, key, index
                    ) in selectOtherOffers.paymentOptions"
                    :key="`${key}-${index}`"
                    :value="JSON.stringify(value)"
                  >
                    {{ value.installmentsNumber }}x
                    {{
                      formatFloatToReal(parseFloat(value.installmentValue, 10))
                    }}
                  </option>
                  <option v-if="!newOffersLoaded">Carregar mais opções</option>
                  <option v-if="newOffersLoaded && !othersOptionsLoaded">
                    Outras opções de negociação
                  </option>
                  <option v-if="selectOtherOffers.paymentOptions.length < 1">
                    Não existem mais opções disponíveis
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="my-3 text-center col-lg-2">
            <button
              class="btn mb-2 btn-primary p-3"
              style="width: 100%; border-radius: 20px"
              :disabled="
                selectOtherOffers.paymentOptions.length < 1 ||
                selectedOption === 'Selecione outra opção' ||
                isEmptyObject(selectedOption)
              "
              @click="resumoAcordo(null)"
            >
              Confirmar
            </button>
          </div>
        </div>
        <div
          class="row border-bottom my-3 mx-auto border-info py-1"
          style="align-items: center"
          v-if="largura > 500 && !loadOffers && !loadOffersPst"
        >
          <div class="col-lg-4">
            <h5>Ou escolha outra opção parcelada da fatura:</h5>
          </div>
          <div class="my-3 text-center col-lg-4">
            <div class="">
              <div
                class="custom-select-wrapper form-group"
                v-if="selectOtherOffers && !loadOffers"
              >
                <select
                  id="ParcelasSelectPst"
                  class="form-control custom-select-arrow mt-2"
                  @change="getValue($event.target.value)"
                >
                  <option
                    v-for="(
                      value, key, index
                    ) in selectOtherOffers.paymentOptions"
                    :key="`${key}-${index}`"
                    :value="JSON.stringify(value)"
                  >
                    {{ value.installmentsNumber }}x
                    {{
                      formatFloatToReal(parseFloat(value.installmentValue, 10))
                    }}
                  </option>
                  <option v-if="!newOffersLoaded && !maxPaymentsOptionReached">Carregar mais opções</option>
                  <option
                    v-if="
                      negociarPagamentoTotal &&
                      newOffersLoaded &&
                      !othersOptionsLoaded
                      && !maxPaymentsOptionReached
                    "
                  >
                    Outras opções de negociação
                  </option>
                  <option v-if="selectOtherOffers.paymentOptions.length < 1">
                    Não existem mais opções disponíveis
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="my-3 text-center col-lg-4">
            <button
              class="btn mb-2 btn-primary p-3"
              style="width: 100%; border-radius: 20px"
              :disabled="
                selectOtherOffers.paymentOptions.length < 1 ||
                selectedOption === 'Selecione outra opção' ||
                isEmptyObject(selectedOption)
              "
              @click="resumoAcordo(null)"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  truncateString,
  formatStringToLowerCase,
  formatFloatToReal,
  isEmptyObject,
  parseNumberFromBrOrNumber,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import HeaderOptions from "../components/HeaderMenu.vue";
import { EventBus } from "@/utils/EventBus";
import { initializeGlobals } from "@/global";

export default {
  name: "propostas",
  components: {
    ProgressLoading,
    HeaderOptions,
  },
  data() {
    return {
      form: {
        offerSelected: null,
      },
      loadOffers: false,
      offers: [],
      offerInfo: [],
      largura: null,
      installment: {},
      loadSetAgreement: false,
      cardOffers: null,
      pstCardOffers: null,
      selectOtherOffers: null,
      selectPstOtherOffers: null,
      negociarPagamentoTotal: false,
      negociarPagamentoTotalAlreadyCalled: false,
      newOffersLoaded: false,
      othersOptionsLoaded: false,
      selectedOption: {},
      pstSelectedOption: {},
      paymentOptionsId: [],
      isPossiblePst: false,
      agreementType: null,
      loadOffersPst: false,
      userAdm: {},
      ipUser: null,
      dropdownOpen: false,
      selectedOptionText: "Selecione",
      onlyInCash: false,
      pstEligibleClient: false,
      showAccordingRules: null,
    };
  },
  methods: {
    formatValue,
    formatData,
    truncateString,
    formatStringToLowerCase,
    formatFloatToReal,
    isEmptyObject,

    ...mapActions("meusContratos", [
      "ActionGetOffersFaturaPortoSeguro",
      "ActionGetOffersPortoSeguro",
    ]),

    async verifyIfHasPst() {
      this.loadOffersPst = true;
      this.negociarPagamentoTotalAlreadyCalled = false;

      try {
        var result = [];
        var res = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          installmentsOptions: [24],
          agreementType: "ParcelamentoRecupera",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          tag: localStorage.getItem("tag"),
          daysDelay: this.offerInfo.daysDelay,
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        result.push(res.data.results);
        this.negociarPagamentoTotal = true;
        this.pstEligibleClient = true;
        await this.negociarPst();
        this.loadOffersPst = false;
      } catch (error) {
        this.negociarPagamentoTotal = false;
        this.loadOffersPst = false;
        return false;
      }
    },

    async negociarPst() {
      localStorage.setItem(
        "currentPageName",
        this.$options.name + "-negociar-valor-total"
      );

      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:link:negociar-valor-total";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ ...eventData });

      this.negociarPagamentoTotal = false;
      this.agreementType = "ParcelamentoRecupera";

      if (parseInt(this.offerInfo.daysDelay) < 31) {
        return;
      }

      if (this.negociarPagamentoTotal) {
        this.negociarPagamentoTotal = false;
      } else {
        this.loadOffersPst = true;
        this.negociarPagamentoTotal = true;
        var result = [];

        // [24,25,36,40,48] primeira chamada
        // [26,27,28,29,30,31,32] clique no select
        // [33,34,35,37,38,39,40] carregar mais parcelas

        try {
          const dueDateD3 = new Date();
          dueDateD3.setDate(dueDateD3.getDate() + 3);
          const dueDate = dueDateD3.toISOString().slice(0, 10);

          var res = await this.ActionGetOffersPortoSeguro({
            clientCode: this.offerInfo.clientCode,
            credor: this.offerInfo.credor,
            installmentsOptions: [12, 24, 36, 48, 60],
            agreementType: "ParcelamentoRecupera",
            contract: this.offerInfo.contract,
            discount: 0,
            inputValue: 0,
            tag: localStorage.getItem("tag"),
            daysDelay: this.offerInfo.daysDelay,
            dueDate,
            UserID: this.userAdm ? this.userAdm.UserID : null,
            UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });

          result.push(res.data.results);

          this.negociarPagamentoTotal = true;
          this.pstEligibleClient = true;

          const paymentOptionCode = result[0].paymentOptionCode;
          let obj = {};
          obj[paymentOptionCode] = [12, 24, 36, 48, 60];
          this.paymentOptionsId.push(obj);

          const pstInstallments = [12, 24, 36, 48, 60];
          const otherInstallments = [12, 24, 36, 48];
          const contractOffer = String(this.offerInfo.contract);

          result.forEach((item) => {
            const options = item.paymentOptions || [];
            const filteredOptions = options.filter((option) =>
              pstInstallments.includes(Number(option.installmentsNumber))
            );
            if (String(item.contract) === contractOffer) {
              this.pstCardOffers = { ...item, paymentOptions: filteredOptions };
            }
          });

          // Fallback: se não houve match por contrato, usa o primeiro resultado (página é de um contrato só)
          if (!this.pstCardOffers && result[0]) {
            const options = result[0].paymentOptions || [];
            const filteredOptions = options.filter((option) =>
              pstInstallments.includes(Number(option.installmentsNumber))
            );
            this.pstCardOffers = { ...result[0], paymentOptions: filteredOptions };
          }

          result.forEach((item) => {
            const options = item.paymentOptions || [];
            const filteredOptions = options.filter((option) =>
              otherInstallments.includes(Number(option.installmentsNumber))
            );
            if (String(item.contract) === contractOffer) {
              this.selectPstOtherOffers = {
                ...item,
                paymentOptions: filteredOptions,
              };
            }
          });

          if (!this.selectPstOtherOffers && result[0]) {
            const options = result[0].paymentOptions || [];
            const filteredOptions = options.filter((option) =>
              otherInstallments.includes(Number(option.installmentsNumber))
            );
            this.selectPstOtherOffers = { ...result[0], paymentOptions: filteredOptions };
          }

          if (this.selectPstOtherOffers && this.selectPstOtherOffers.paymentOptions && this.selectPstOtherOffers.paymentOptions.length > 0) {
            this.pstSelectedOption = this.selectPstOtherOffers.paymentOptions[0];
          }
          this.loadOffersPst = false;
          this.negociarPagamentoTotalAlreadyCalled = true;

          this.emitUpdatePageViewEvent(
            "dashboard/negociar-valor-total/propostas"
          );
        } catch (error) {
          // this.flashMessage.show({
          //   time: 3000,
          //   status: "error",
          //   position: "top right",
          //   title: "Erro",
          //   message:
          //     "Não foi possível buscar informações de negociação total, tente novamente mais tarde!",
          // });
          this.buildAndSetUserData(
            this.userDataStorage.cpfCnpj,
            this.userDataStorage.id,
            this.protocol + "//" + this.host + "/dashboard",
            "Dashboard"
          );
          this.updateCustomData();
          this.eventCallbackNegociarFailureGTM(
            error,
            "Não foi possível buscar informações de negociação total, tente novamente mais tarde!"
          );
          this.loadOffersPst = false;
        }
      }
    },

    emitUpdatePageViewEvent(pageName) {
      EventBus.$emit("updatePageView", pageName);
    },

    async newOptions() {
      // this.agreementType = "ParcelamentoRecupera";
      if (this.newOffersLoaded) {
        return;
      }
      this.loadOffers = true;
      const today = new Date();
      today.setDate(today.getDate() + 3);
      var result = [];

      try {
        var res = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          dueDate: today.toJSON().split("T")[0],
          installmentsOptions: [26, 27, 28, 29, 30, 31, 32],
          agreementType: "ParcelamentoFatura",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        result.push(res.data.results);

        const paymentOptionCode = result.paymentOptionCode;
        let obj = {};
        obj[paymentOptionCode] = [
          26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
        ];
        this.paymentOptionsId.push(obj);

        result.forEach((item) => {
          const filteredOptions = item.paymentOptions.filter((option) => {
            const installments = [
              26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
            ];
            return installments.includes(option.installmentsNumber);
          });

          filteredOptions.map((value) => {
            const installment = this.selectOtherOffers.paymentOptions.filter(
              (option) => {
                return option.installmentsNumber === value.installmentsNumber;
              }
            );

            if (installment.length < 1) {
              this.selectOtherOffers.paymentOptions.push(value);
            }
          });

          if (this.offerInfo.contract === item.contract) {
            this.selectOtherOffers = {
              ...item,
              paymentOptions: this.selectOtherOffers.paymentOptions,
            };
          }
        });
        this.selectedOption = this.selectOtherOffers.paymentOptions[0];

        this.newOffersLoaded = true;
        this.loadOffers = false;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        this.eventCallbackNegociarFailureGTM(error, null);
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.loadOffers = false;
      }
    },

    async newOptionsPst() {
      if (this.newOffersLoaded) {
        return;
      }
      this.loadOffers = true;
      const today = new Date();
      today.setDate(today.getDate() + 3);
      var result = [];

      try {
        var res = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          dueDate: today.toJSON().split("T")[0],
          installmentsOptions: [13, 14, 15, 16, 17, 18, 19],
          agreementType: "ParcelamentoRecupera",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        result.push(res.data.results);

        const paymentOptionCode = result.paymentOptionCode;
        let obj = {};
        obj[paymentOptionCode] = [
          13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
        ];
        this.paymentOptionsId.push(obj);

        result.forEach((item) => {
          const filteredOptions = item.paymentOptions.filter((option) => {
            const installments = [
              13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
            ];
            return installments.includes(option.installmentsNumber);
          });

          filteredOptions.map((value) => {
            const installment = this.selectPstOtherOffers.paymentOptions.filter(
              (option) => {
                return option.installmentsNumber === value.installmentsNumber;
              }
            );

            if (installment.length < 1) {
              this.selectPstOtherOffers.paymentOptions.push(value);
            }
          });

          if (this.offerInfo.contract === item.contract) {
            this.selectPstOtherOffers = {
              ...item,
              paymentOptions: this.selectPstOtherOffers.paymentOptions,
            };
          }
        });

        if (this.selectPstOtherOffers && this.selectPstOtherOffers.paymentOptions && this.selectPstOtherOffers.paymentOptions.length > 0) {
          this.selectPstOtherOffers.paymentOptions.sort((a, b) => {
            return a.installmentsNumber - b.installmentsNumber;
          });

          this.pstSelectedOption = this.selectPstOtherOffers.paymentOptions[0];
        }

        this.newOffersLoaded = true;
        this.loadOffers = false;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        this.eventCallbackNegociarFailureGTM(error, null);
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.loadOffers = false;
      }
    },

    async loadOthersOptions() {
      // this.agreementType = "ParcelamentoRecupera";
      this.othersOptionsLoaded = false;

      this.loadOffers = true;
      const today = new Date();
      today.setDate(today.getDate() + 3);
      var result = [];

      try {
        var res = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          dueDate: today.toJSON().split("T")[0],
          installmentsOptions: [33, 34, 35, 37, 38, 39, 40],
          agreementType: "ParcelamentoFatura",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        result.push(res.data.results);

        const paymentOptionCode = result.paymentOptionCode;
        let obj = {};
        obj[paymentOptionCode] = [33, 34, 35, 37, 38, 39, 40];
        this.paymentOptionsId.push(obj);

        result.forEach((item) => {
          const filteredOptions = item.paymentOptions.filter((option) => {
            const installments = [33, 34, 35, 37, 38, 39, 40];
            return installments.includes(option.installmentsNumber);
          });

          filteredOptions.map((value) => {
            const installment = this.selectOtherOffers.paymentOptions.filter(
              (option) => {
                return option.installmentsNumber === value.installmentsNumber;
              }
            );

            if (installment.length < 1) {
              this.selectOtherOffers.paymentOptions.push(value);
            }
          });
          if (this.offerInfo.contract === item.contract) {
            this.selectOtherOffers = {
              ...item,
              paymentOptions: this.selectOtherOffers.paymentOptions,
            };
          }
        });

        this.selectedOption = this.selectOtherOffers.paymentOptions[0];

        this.othersOptionsLoaded = true;
        this.loadOffers = false;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        this.eventCallbackNegociarFailureGTM(error, null);
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.loadOffers = false;
      }
    },

    async loadOthersOptionsPst() {
      this.othersOptionsLoaded = false;

      this.loadOffers = true;
      const today = new Date();
      today.setDate(today.getDate() + 3);
      var result = [];

      try {
        var res = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          dueDate: today.toJSON().split("T")[0],
          installmentsOptions: [33, 34, 35, 37, 38, 39, 40],
          agreementType: "ParcelamentoRecupera",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        result.push(res.data.results);

        const paymentOptionCode = result.paymentOptionCode;
        let obj = {};
        obj[paymentOptionCode] = [33, 34, 35, 37, 38, 39, 40];
        this.paymentOptionsId.push(obj);

        result.forEach((item) => {
          const filteredOptions = item.paymentOptions.filter((option) => {
            const installments = [33, 34, 35, 37, 38, 39, 40];
            return installments.includes(option.installmentsNumber);
          });

          filteredOptions.map((value) => {
            const installment = this.selectPstOtherOffers.paymentOptions.filter(
              (option) => {
                return option.installmentsNumber === value.installmentsNumber;
              }
            );

            if (installment.length < 1) {
              this.selectPstOtherOffers.paymentOptions.push(value);
            }
          });
          if (this.offerInfo.contract === item.contract) {
            this.selectPstOtherOffers = {
              ...item,
              paymentOptions: this.selectPstOtherOffers.paymentOptions,
            };
          }
        });

        if (this.selectPstOtherOffers && this.selectPstOtherOffers.paymentOptions && this.selectPstOtherOffers.paymentOptions.length > 0) {
          this.pstSelectedOption = this.selectPstOtherOffers.paymentOptions[0];
        }

        this.othersOptionsLoaded = true;
        this.loadOffers = false;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        this.eventCallbackNegociarFailureGTM(error, null);
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.loadOffers = false;
      }
    },

    async back() {
      this.eventClickArrowToBackGTM();
      this.negociarPagamentoTotal = false;
      await this.loadParcelamentoFatura();
      // await this.verifyIfHasPst();
    },

    isDatePassedMoreThan30Days(dateString) {
      const date = new Date(dateString);
      const currentDate = new Date();

      const differenceInTime = currentDate.getTime() - date.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      return differenceInDays > 30;
    },

    validateDaysDelay() {
      const daysDelay = this.offerInfo.daysDelay;
      var onlyInCash = false;

      switch (daysDelay) {
        case 14:
        case 15:
        case 16:
          onlyInCash = true;
          break;
        case 43:
        case 44:
        case 45:
          onlyInCash = true;
          break;
        case 63:
        case 64:
        case 65:
          onlyInCash = true;
          break;
        // default:
        //   break;
      }

      return onlyInCash;
    },

    async loadParcelamentoFatura() {
      this.loadOffers = true;
      this.agreementType = "ParcelamentoFatura";

      try {
        var result = await this.ActionGetOffersFaturaPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          agreementType: "ParcelamentoFatura",
          contract: this.offerInfo.contract,
          tag: localStorage.getItem("tag"),
          daysDelay: this.offerInfo.daysDelay,
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
          paymentValue: parseNumberFromBrOrNumber(this.offerInfo.paymentValue),
        });

        var installmentsNumbers = [];

        this.onlyInCash = this.validateDaysDelay();

        installmentsNumbers = [1, 3, 6, 12, 24];

        if (this.onlyInCash) {
          installmentsNumbers = [1];
        }

        // if (!this.pstEligibleClient) {
        //   installmentsNumbers = [1, 3, 6, 12, 24];
        // } else {
        //   installmentsNumbers = [1];
        // }

        

        const filteredOptions = result.paymentOptions.filter((option) => {
          const installments = installmentsNumbers;
          return installments.includes(option.installmentsNumber);
        });

        this.cardOffers = {
          ...result,
          paymentOptions: filteredOptions,
        };

        const filteredOptionsSelected = result.paymentOptions.filter(
          (option) => {
            const installments = installmentsNumbers;
            if (this.onlyInCash) {
              return installments.includes(option.installmentsNumber);
            } else {
              return !installments.includes(option.installmentsNumber);
            }
          }
        );
        this.selectOtherOffers = {
          ...result,
          paymentOptions: filteredOptionsSelected,
        };

        this.maxPaymentsOptionReached = parseInt(this.offerInfo.maxPaymentsOption) === parseInt(result.paymentOptions[result.paymentOptions.length - 1].installmentsNumber);

        console.log('this.cardOffers: ' + JSON.stringify(this.cardOffers))
        console.log('parseInt(this.offerInfo.maxPaymentsOption): ' + JSON.stringify(parseInt(this.offerInfo.maxPaymentsOption)))
        console.log('result.paymentOptions[result.paymentOptions.length - 1]: ' + JSON.stringify(result.paymentOptions[result.paymentOptions.length - 1]))
        console.log('this.maxPaymentsOptionReached: ' + JSON.stringify(this.maxPaymentsOptionReached))

        // this.selectedOption = `Entrada  &nbsp;`;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.eventCallbackNegociarFailureGTM(error, null);
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.loadOffers = false;
      }
    },

    getValue(selectedValue) {
      if (selectedValue === "Selecionar") {
        this.selectedOption = selectedValue;
        return;
      }
      if (selectedValue === "Carregar mais opções") {
        this.newOptions();
      }
      if (selectedValue === "Outras opções de negociação") {
        this.loadOthersOptions();
      } else {
        const value = JSON.parse(selectedValue);
        this.eventSelecionarOutrasOpcoesNegociacaoGTM(value);
        return (this.selectedOption = value);
      }
    },

    getValuePst(selectedValue) {
      if (selectedValue === "Selecionar") {
        this.pstSelectedOption = selectedValue;
        return;
      }
      if (selectedValue === "Carregar mais opções") {
        this.newOptionsPst();
      }
      if (selectedValue === "Outras opções de negociação") {
        this.loadOthersOptionsPst();
      } else {
        const value = JSON.parse(selectedValue);
        this.eventSelecionarOutrasOpcoesNegociacaoGTM(value);
        return (this.pstSelectedOption = value);
      }
    },

    async toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDivOptions() {
      var options = document.getElementById("listOptions");
      if (options) {
        options.style.display = "none";
      }
    },
    async selectOption(value) {
      if (this.selectedOption === value) {
        this.selectedOption = {};
        this.selectedOptionText = "Selecionar";
      } else {
        // Caso contrário, marque-a como selecionada
        this.selectedOptionText = `R$${formatFloatToReal(
          value.installmentValue
        )} + ${value.installmentsNumber - 1}x de R$${formatFloatToReal(
          value.installmentValue
        )} ${
          value.discount > 0
            ? value.discount.toFixed(2).replace(".", ",") + "%"
            : ""
        }`;
        this.selectedOption = value;
      }
      // Fecha o dropdown após a seleção
      this.closeDivOptions();
      // this.dropdownOpen = false;
    },

    async selectOptionPst(value) {
      if (this.pstSelectedOption === value) {
        this.pstSelectedOption = {};
        this.selectedOptionTextPst = "Selecionar";
      } else {
        // Caso contrário, marque-a como selecionada
        this.selectedOptionTextPst = `R$${formatFloatToReal(
          value.installmentValue
        )} + ${value.installmentsNumber - 1}x de R$${formatFloatToReal(
          value.installmentValue
        )} ${
          value.discount > 0
            ? value.discount.toFixed(2).replace(".", ",") + "%"
            : ""
        }`;
        this.pstSelectedOption = value;
      }
      // Fecha o dropdown após a seleção
      this.closeDivOptions();
      // this.dropdownOpen = false;
    },

    async resumoAcordo(offer) {
      if (offer === null) {
        offer = this.selectedOption;
      }

      this.eventClickConfirmarGTM(offer);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/resumoAcordo",
        "resumo-acordo"
      );
      this.updateCustomData();
      this.$router.push({
        name: "resumoAcordo",
        params: {
          offerInfo: {
            clientCode: this.offerInfo.clientCode,
            credor: this.offerInfo.credor,
            product: this.offerInfo.product,
            dueDate: this.cardOffers.dueDate,
            dueDateOriginal: this.offerInfo.dueDate,
            contract: this.offerInfo.contract,
            paymentOptionCode: this.cardOffers.paymentOptionCode,
            paymentOptionsCodeIds: this.paymentOptionsId,
            allowRenegociation: this.offerInfo.allowRenegociation,
            invoiceOption: offer.invoiceOption,
            agreementType: this.agreementType,
            paymentValue: this.offerInfo.paymentValue,
            originalValue: this.offerInfo.originalValue,
            daysDelay: this.offerInfo.daysDelay,
            pstOriginalValue: this.offerInfo.pstOriginalValue,
            ...offer,
          },
          fromProposals: true,
          isPst: false,
          from: "propostas",
          // offerInfo: this.offerInfo,
        },
      });
    },

    async resumoAcordoPst(offer) {
      if (offer === null) {
        offer = this.pstSelectedOption;
      }

      this.eventClickConfirmarGTM(offer);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/resumoAcordo",
        "resumo-acordo"
      );
      this.updateCustomData();
      this.$router.push({
        name: "resumoAcordo",
        params: {
          offerInfo: {
            clientCode: this.offerInfo.clientCode,
            credor: this.offerInfo.credor,
            product: this.offerInfo.product,
            dueDate: this.cardOffers.dueDate,
            dueDateOriginal: this.offerInfo.dueDate,
            contract: this.offerInfo.contract,
            paymentOptionCode: this.cardOffers.paymentOptionCode,
            paymentOptionsCodeIds: this.paymentOptionsId,
            allowRenegociation: this.offerInfo.allowRenegociation,
            invoiceOption: offer.invoiceOption,
            agreementType: this.agreementType,
            paymentValue: this.offerInfo.paymentValue,
            originalValue: this.offerInfo.originalValue,
            daysDelay: this.offerInfo.daysDelay,
            pstOriginalValue: this.offerInfo.pstOriginalValue,
            ...offer,
          },
          fromProposals: true,
          isPst: true,
          from: "propostas",
        },
      });
    },

    compareDates(date) {
      let parts = date.split("-");
      let today = new Date();

      date = new Date(parts[0], parts[1] - 1, parts[1]);

      return date >= today ? true : false;
    },

    home() {
      this.eventClickArrowToBackGTM();
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard",
        "Dashboard"
      );
      this.updateCustomData();
      this.$router.push({
        name: "dashboard",
        params: this.offerInfo,
      });
    },

    buildAndSetUserData(doc, id, pageLocation, pageName) {
      const userData = {
        cpfCnpj: doc,
        id: id,
        page_location: pageLocation,
        pageName: pageName,
      };
      localStorage.setItem("userData", JSON.stringify(userData));
    },

    eventClickArrowToBackGTM() {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:button:voltar";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    eventClickConfirmarGTM(offer) {
      var typeConfirm =
        this.negociarPagamentoTotal && this.negociarPagamentoTotalAlreadyCalled
          ? "confirmar"
          : "confirmar";
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = `click:button:${typeConfirm}`;

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: this.buildPayloadOfferChoose(offer),
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    buildPayloadOfferChoose(offer) {
      var formatedPayload = null;
      if (offer.installmentsNumber === 1) {
        formatedPayload = "pagamento-a-vista";
      } else {
        formatedPayload = `parcelado-em-${offer.installmentsNumber}-vezes`;
      }
      return formatedPayload;
    },

    buildPayloadOfferChooseOtherOptionsOfNegociation(offer) {
      var formatedPayload = null;
      formatedPayload = `${offer.installmentsNumber}x ${this.formatFloatToReal(
        parseFloat(offer.installmentValue, 10)
      )}`;

      return truncateString(formatedPayload, 100);
    },

    eventSelecionarOutrasOpcoesNegociacaoGTM(offer) {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "selecionou:option:outra-opcao-de-negociacao";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: this.buildPayloadOfferChooseOtherOptionsOfNegociation(offer),
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    eventCallbackNegociarFailureGTM(error, msg) {
      console.log("errorrrrr: " + JSON.stringify(error.status));
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "solicitar-opcoes-pagamento:alert";
      const eventLabel = truncateString(
        msg !== null
          ? msg
          : "Não foi possível buscar ofertas, tente novamente mais tarde!",
        100
      );
      const eventCode = error.status;
      const eventErrorService = "";
      const eventAlertService = truncateString(error.data.message, 100);
      const eventAlert = "select_content";
      const eventAlertType = "erro";
      const eventData = {
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: eventLabel,
        alert_code: eventCode,
        error_service: eventErrorService,
        alert_service_message: eventAlertService,
        alert_event: eventAlert,
        alert_type: eventAlertType,
      };

      window.dataLayer.push({ event: "alert", ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    },

    moveAvistaToEndInCard(card) {
      if (!card?.paymentOptions?.length) return card;

      const idx = card.paymentOptions.findIndex(
        (o) => Number(o.installmentsNumber) === 1
      );
      if (idx > -1 && idx !== card.paymentOptions.length - 1) {
        const [avista] = card.paymentOptions.splice(idx, 1);
        card.paymentOptions.push(avista);
      }
      return card;
    },

    chooseTopOffer(daysDelay, hasPst) {
      const d = Number(daysDelay);
      switch (true) {
        case d <= 35:
          return "avista";
        case d >= 36 && d <= 59:
          return "parcelamento_fatura";
        case d >= 60 && d <= 90:
          return hasPst ? "pst" : "parcelamento_fatura";
        default:
          return hasPst ? "pst" : "parcelamento_fatura";
      }
    },
  },

  async created() {
    this.updateCustomData();
    this.ipUser = localStorage.getItem("ipUser");
    localStorage.setItem("currentPageName", this.$options.name);
    this.userDataStorage = JSON.parse(localStorage.getItem("userData"));
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.protocol = window.location.protocol;
    this.host = window.location.host;
    this.path = window.location.pathname;
    this.pageLocation = this.protocol + "//" + this.host + this.path;
    this.negociarPagamentoTotal = false;
    this.negociarPagamentoTotalAlreadyCalled = false;
    this.offerInfo = this.$route.params.offerInfo;
    await this.negociarPst();
    await this.loadParcelamentoFatura();

    this.showAccordingRules = this.chooseTopOffer(
      this.offerInfo.daysDelay,
      this.pstEligibleClient
    );



    console.log('this.offerInfo: ' + JSON.stringify(this.offerInfo))

    if (this.showAccordingRules === "parcelamento_fatura") {
      this.moveAvistaToEndInCard(this.cardOffers);
    }

    this.largura = window.screen.width;
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },

    topOffer() {
      return this.chooseTopOffer(
        this.offerInfo.daysDelay,
        !!this.pstEligibleClient
      );
    },
  },
};
</script>

<style scoped>
.custom-select-wrapper {
  position: relative;
}

.custom-select-arrow {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  background-color: white;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23666' stroke-width='1.5' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}
</style>
